import { navigate } from '@redwoodjs/router'

import { useHomePage } from '../../hooks/use-home-page'
import { useMyUser } from '../AppStateContextLayout/utils'

type Props = {
  children?: React.ReactNode
}

/**
 * Guards routes that require Admin or AI team member access.
 * Used for AI Assistant Train, Routing, and Settings pages.
 */
const AIAdminLayout = (props: Props) => {
  const { children } = props
  const me = useMyUser()
  const homePage = useHomePage()

  if (!me) {
    return <>{children}</>
  }
  if (me.isGovWellStaff) {
    return <>{children}</>
  }
  if (me.type === 'Government' && (me.group === 'Admin' || me.isAIStaffMember)) {
    return <>{children}</>
  }
  navigate(homePage)
  return null
}

export default AIAdminLayout
